
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points faibles?`}</em></p>
    <p>{`Ce vaccin a pris du retard. Dans un premier temps, Novavax voulait déposer une
demande en urgence au Royaume-Uni au deuxième trimestre 2021. Cela pourrait
aussi poser problème au dispositif Covax. Novavax a en effet annoncé en février
2021 qu'il fournirait 1,1 million de doses à ce consortium qui distribue des
vaccins dans le monde entier.`}</p>
    <p>{`Novavax travaille sur une nouvelle version de son produit contre les variants.
Une telle mise au point devrait prendre plus de temps que pour les vaccins
utilisant l’ARN messager. La raison est technique: il faut produire en
laboratoire la protéine injectée; avec l’ARNm, c’est notre corps qui fait ce
travail!`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;